/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import usePresupuesto from "../../hooks/usePresupuesto";
import ModaladdPadre from "./Modals/ModalPadre";
import ModalSubpadre from "./Modals/ModaSubpadre";
import ModalHijo from "./Modals/ModalHijo";
import ModalFechas from "./Modals/ModalFecha";
import ModalEditar from "./Modals/ModalEditarCampo";
import ModalElim from "./Modals/ModalEliminar";
import DataTable from "../../components/DataTable/DataTable";
import GroupedTable from "../../components/DataTable/GroupedTable";
import { formatCurrency } from "../../utils/formato";
import { hideLoader, showLoader, setTitle } from "../../reducers/loaderReducer";
import { useDispatch } from "react-redux";
import useLogin from "../../hooks/useLogin";
import Swal from "sweetalert2";

/** Totales que GroupedTable suma al pie de cada grupo. */
const TOTALES = [
  { field: "monto", label: "Subtotal" },
  { field: "iva", label: "IVA" },
  { field: "total", label: "Total" },
];



export default function Index() {
  const { logout, token, user_rol } = useLogin();

  const dispatch = useDispatch();
  const { loading, message, success, Presupuestos, Subtotal, Iva_, Total_, PresupuestosGetService, PresupuestosPadreUpdateService, PadresMontoGetService } = usePresupuesto();
  const [Children, setChildren] = useState([]);
  const [Padre, setPadre] = useState([]);
  const [PadreID, setPadreID] = useState("");
  const [HijoID, setHijoID] = useState("");
  const [NombreH, setNombreH] = useState("");
  const [NivelID, setNivelID] = useState("");
  const [VariableID, setVariableID] = useState("");
  const [array_titles, setarray_titles] = useState([]);

  /*
   * Editar Campos
   */
  const [ModalEditarCampo, setModalEditarCampo] = useState(false);
  const [Campo, setCampo] = useState("");
  const [ValorCampo, setValorCampo] = useState("");
  const [IDCampo, setIDCampo] = useState("");
  const [Tipo, setTipo] = useState("");

  useEffect(() => {
    if (success == true) {
      PresupuestosGetService(token);
      //setActivarCampoNu(null);
      //setActivarCampoN(null);
    }
  }, [PresupuestosGetService, success]);

  /*
   * Agregar Padre
   */
  const [ModalPadre, setModalPadre] = useState(false);
  const [IDPadre, setIDPadre] = useState("");
  const [UpdatePadre, setUpdatePadre] = useState(false);
  const [NombrePadre, setNombrePadre] = useState("");
  const [NumeracionPadre, setNumeracionPadre] = useState("");
  const [NivelPadre, setNivelPadre] = useState(1);
  const [GrupoPadre, setGrupoPadre] = useState("");
  /*
   * Agregar Subpadre
   */
  const [ModalSub, setModalSub] = useState(false);
  const [NombreSub, setNombreSub] = useState("");
  /*
   * Agregar hijo
   */
  const [NomPadre, setNomPadre] = useState("");
  const [modalHijo, setmodalHijo] = useState(false);
  const [NombreVari, setNombreVari] = useState("");
  const [NumeracionVari, setNumeracionVari] = useState("");
  const [Cantidad, setCantidad] = useState(0);
  const [Unidades, setUnidades] = useState("");
  const [X, setX] = useState(0);
  const [MostrarVariable, setMostrarVariable] = useState(false);
  const [IsChecked, setIsChecked] = useState(true);
  const [Fecha, setFecha] = useState("");
  const [Opcion, setOpcion] = useState([]);
  const [Cuantos, setCuantos] = useState(0);
  const [Costo, setCosto] = useState(0);
  const [Subtota, setSubtota] = useState(0);
  const [Iva, setIva] = useState(0);
  const [Total, setTotal] = useState(0);

  /*
   * Estados Fecha
   */
  const [ModalFecha, setModalFecha] = useState(false);
  const [IDFecha, setIDFecha] = useState("");

  /*
   * Eliminar Cuenta
   */
  const [ModalEliminar, setModalEliminar] = useState(false);
  const [Cuenta, setCuenta] = useState("");
  const [NomCuenta, setNomCuenta] = useState("");
  const [IDCuenta, setIDCuenta] = useState("");
  const [CuentaTipo, setCuentaTipo] = useState("");

  useEffect(() => {
    PresupuestosGetService(token);
  }, [PresupuestosGetService]);

  useEffect(() => {
    // Se quita el loader cuando la petición termina, con o sin resultados: antes
    // pedía length > 0 y si el listado venía vacio la pantalla se quedaba
    // atorada en la pantalla de carga.
    if (Presupuestos.length >= 0) {
      dispatch(hideLoader());
      dispatch(setTitle(""));
    }
  }, [Presupuestos]);

  useEffect(() => {
    dispatch(setTitle("Descargando presupuestos"));
    dispatch(showLoader());
    PadresMontoGetService(token);
  }, [PadresMontoGetService]);

  /**
   * Regresar en la jerarquía de cuentas.
   *
   * Antes esto caminaba de vuelta con Padre[0].children[0].children[0]... según
   * el nivel: siempre tomaba el PRIMER hijo de cada nivel, así que si habías
   * entrado por el segúndo o el tercero, el botón te dejaba en otra cuenta o en
   * ninguna. Ahora se usa el camino que ya se venía guardando en array_titles.
   *
   * Con `destino` (las migas de pan) se corta el camino hasta esa cuenta; sin
   * él, se sube un solo nivel.
   */
  const returnChildren = (destino = null, type = null) => {
    const camino = array_titles;

    let nuevoCamino;
    if (type === "nivel" && destino) {
      const posicion = camino.findIndex((paso) => paso.id === destino.id);
      nuevoCamino = posicion === -1 ? camino.slice(0, -1) : camino.slice(0, posicion + 1);
    } else {
      nuevoCamino = camino.slice(0, -1);
    }

    setarray_titles(nuevoCamino);

    const ultimo = nuevoCamino[nuevoCamino.length - 1];
    // Sin camino se vuelve a la raíz: la pantalla muestra las cuentas padre.
    setChildren(ultimo ? SumatoriaHijos(ultimo).children ?? [] : []);
  };

  const retornarNivel = (a) => {
    if (a.nivel_id === 2) {
      setarray_titles((array) => [...array, a]);
      setPadre([a]);
      const numeros = SumatoriaHijos(a);
      setChildren(numeros.children);
    } else {
      setarray_titles((array) => [...array, a]);
      const numeros = SumatoriaHijos(a);
      setChildren(numeros.children);
    }
  };

  const formatNumber = (number) =>
    new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(number);

  const Sumatoria = (e) => {
    for (let i = 0; i < e.children.length; i++) {
      const obtenerhijo = e.children[i];
      if (obtenerhijo.subpadre == "Si") {
        const subtotalHijo = obtenerhijo.children.reduce(
          (acumulador, currenci) =>
            currenci.subpadre == "No"
              ? acumulador + parseFloat(currenci.subtotal)
              : acumulador,
          0
        );
        const ivaHijo = obtenerhijo.children.reduce(
          (acumulador, currenci) =>
            currenci.subpadre == "No"
              ? acumulador + parseFloat(currenci.iva)
              : acumulador,
          0
        );
        const totalHijo = obtenerhijo.children.reduce(
          (acumulador, currenci) =>
            currenci.subpadre == "No"
              ? acumulador + parseFloat(currenci.total)
              : acumulador,
          0
        );
        obtenerhijo.subtotal = subtotalHijo;
        obtenerhijo.iva = ivaHijo;
        obtenerhijo.total = totalHijo;
      }
    }
    setChildren(e.children);
    setNomPadre(e.Nombre);
  };

  const SumatoriaHijos = (e) => {
    for (let i = 0; i < e.children.length; i++) {
      const obtenerhijo = e.children[i];
      if (obtenerhijo.subpadre == "Si") {
        const subtotalHijo = obtenerhijo.children.reduce(
          (acumulador, currenci) =>
            currenci.subpadre == "No"
              ? acumulador + parseFloat(currenci.subtotal)
              : acumulador,
          0
        );
        const ivaHijo = obtenerhijo.children.reduce(
          (acumulador, currenci) =>
            currenci.subpadre == "No"
              ? acumulador + parseFloat(currenci.iva)
              : acumulador,
          0
        );
        const totalHijo = obtenerhijo.children.reduce(
          (acumulador, currenci) =>
            currenci.subpadre == "No"
              ? acumulador + parseFloat(currenci.total)
              : acumulador,
          0
        );
        obtenerhijo.subtotal = subtotalHijo;
        obtenerhijo.iva = ivaHijo;
        obtenerhijo.total = totalHijo;
      }
    }
    return e;
  };

  const togglePadre = () => {
    setModalPadre(!ModalPadre);
    setUpdatePadre(false);
    setIDPadre("");
    setNombrePadre("");
    setNumeracionPadre("");
    setNivelPadre("");
    setGrupoPadre("");
  };

  const toggleSubPadre = () => {
    setModalSub(!ModalSub);
    setPadreID("");
    setHijoID("");
    setNombreSub("");
    setNivelID("");
  };

  const toggleHijo = () => {
    setmodalHijo(!modalHijo);
    setPadreID("");
    setHijoID("");
    setNombreH("");
    setNivelID("");
    setVariableID("");
    setCantidad("");
    setUnidades("");
    setX("");
    setMostrarVariable(false);
    setNombreVari("");
    setNumeracionVari("");
    setIsChecked(true);
    setFecha("");
    setOpcion("");
    setCuantos("");
    setCosto("");
    setSubtota("");
    setIva("");
    setTotal("");
  };

  const toggleFecha = () => {
    setModalFecha(!ModalFecha);
    setIDFecha("");
  };

  const toggleEliminar = () => {
    setModalEliminar(!ModalEliminar);
    setCuenta("");
    setNomCuenta("");
    setCuentaTipo("");
    setIDCuenta("");
  };

  const toggleEditar = () => {
    setModalEditarCampo(!ModalEditarCampo);
    setCampo("");
    setValorCampo("");
    setIDCampo("");
    setTipo("");
  };

  useEffect(() => {
    if (success) {
      Swal.close();
      Swal.fire({
        icon: "success",
        title: "Exito",
        confirmButtonColor: "#3b82f6",
        text: message,
      });
    }
  }, [message, success])

  /** Celda de texto que abre el modal de edicion al hacer clic. */
  const celdaEditable = (campo, tipo) => (fila) => (
    <span
      className="presupuestos-editable"
      onClick={() => {
        setCampo(campo);
        setValorCampo(fila[campo]);
        setIDCampo(fila.id);
        setTipo(tipo);
        setModalEditarCampo(true);
      }}
    >
      {fila[campo]}
    </span>
  );

  const columnaMoneda = (field, title) => ({
    field,
    title,
    align: "center",
    filterable: false,
    sortValue: (fila) => Number(fila[field]) || 0,
    render: (fila) => formatCurrency(fila[field]),
  });

  const puedeEliminar =
    user_rol === "super administrador" || user_rol === "cliente";

  const parentColumns = [
    {
      field: "Cuenta presupuestal",
      title: "Cuenta presupuestal",
      width: 160,
      align: "center",
      render: celdaEditable("Cuenta presupuestal", "padre"),
    },
    {
      field: "Nombre",
      title: "Nombre de la cuenta",
      width: 228,
      align: "center",
      render: celdaEditable("Nombre", "padre"),
    },
    columnaMoneda("monto", "Subtotal"),
    columnaMoneda("iva", "IVA"),
    columnaMoneda("total", "Total"),
    {
      field: "_subpadre",
      title: "Subpadre",
      width: 85,
      align: "center",
      sortable: false,
      filterable: false,
      render: (fila) => (
        <button
          className="btn btn-info btn-sm btn-icon-text"
          title="Agregar subpadre"
          onClick={() => {
            setPadreID(fila.id);
            setHijoID(null);
            setNivelID(fila.nivel_id);
            setModalSub(true);
          }}
        >
          <i className="mdi mdi-plus-box"></i>
        </button>
      ),
    },
    {
      field: "_hijos",
      title: "Hijos",
      width: 60,
      align: "center",
      sortable: false,
      filterable: false,
      render: (fila) => (
        <button
          className="btn btn-primary btn-sm btn-icon-text"
          title="Agregar hijo"
          onClick={() => {
            setPadreID(fila.id);
            setHijoID(null);
            setNivelID(fila.nivel_id);
            setmodalHijo(true);
          }}
        >
          <i className="mdi mdi-plus-box"></i>
        </button>
      ),
    },
    {
      field: "_drill",
      title: "Ver",
      width: 80,
      align: "center",
      sortable: false,
      filterable: false,
      render: (fila) =>
        fila.children.length !== 0 && (
          <button
            className="btn btn-success btn-sm btn-icon-text"
            title="Ver cuentas hijas"
            onClick={() => Sumatoria(fila)}
          >
            <i className="mdi mdi-arrow-right-bold"></i>
          </button>
        ),
    },
  ];

  if (puedeEliminar) {
    parentColumns.push({
      field: "_delete",
      title: "",
      width: 60,
      align: "center",
      sortable: false,
      filterable: false,
      render: (fila) => (
        <button
          className="btn btn-danger btn-sm btn-icon-text"
          title="Eliminar cuenta"
          onClick={() => {
            setCuenta(fila.numeracion);
            setNomCuenta(fila.nombre);
            setIDCuenta(fila.id);
            setCuentaTipo("padre");
            setModalEliminar(true);
          }}
        >
          <i className="mdi mdi-delete-forever"></i>
        </button>
      ),
    });
  }

  const childColumns = [
    {
      field: "cuenta_presupuental",
      title: "Cuenta presupuental",
      width: 155,
      align: "center",
    },
    {
      field: "Nombre",
      title: "Nombre",
      width: 200,
      align: "center",
      render: celdaEditable("Nombre", "hijo"),
    },
    { field: "padre_nombre", title: "Cuenta Raiz", width: 200 },
    { field: "nombre_hijo", title: "Cuenta Padre", width: 200 },
    {
      field: "Cantidad",
      title: "Cantidad",
      width: 85,
      align: "center",
      filterable: false,
      render: celdaEditable("Cantidad", "hijo"),
    },
    {
      field: "Unidad",
      title: "Unidad",
      width: 85,
      align: "center",
      filterable: false,
      render: celdaEditable("Unidad", "hijo"),
    },
    {
      field: "X",
      title: "X",
      width: 85,
      align: "center",
      filterable: false,
      render: celdaEditable("X", "hijo"),
    },
    columnaMoneda("subtotal", "Subtotal"),
    columnaMoneda("iva", "IVA"),
    columnaMoneda("total", "Total"),
    {
      field: "_fechas",
      title: "Fechas",
      width: 69,
      align: "center",
      sortable: false,
      filterable: false,
      render: (fila) =>
        fila.subpadre === "No" && (
          <button
            className="btn btn-secondary btn-sm btn-icon-text"
            title="Fechas de pago"
            onClick={() => {
              setIDFecha(fila.id);
              setModalFecha(true);
            }}
          >
            <i className="mdi mdi-calendar"></i>
          </button>
        ),
    },
    {
      field: "_subpadre",
      title: "Subpadre",
      width: 85,
      align: "center",
      sortable: false,
      filterable: false,
      render: (fila) => (
        <button
          className="btn btn-info btn-sm btn-icon-text"
          title="Agregar subpadre"
          onClick={() => {
            setPadreID(fila.presupuestos_padre_id);
            setHijoID(fila.id);
            setNivelID(fila.nivel_id);
            setModalSub(true);
          }}
        >
          <i className="mdi mdi-plus-box"></i>
        </button>
      ),
    },
    {
      field: "_hijos",
      title: "Hijos",
      width: 65,
      align: "center",
      sortable: false,
      filterable: false,
      render: (fila) => (
        <button
          className="btn btn-primary btn-sm btn-icon-text"
          title="Agregar hijo"
          onClick={() => {
            setPadreID(fila.presupuestos_padre_id);
            setHijoID(fila.id);
            setNivelID(fila.nivel_id);
            setmodalHijo(true);
          }}
        >
          <i className="mdi mdi-plus-box"></i>
        </button>
      ),
    },
    {
      field: "_drill",
      title: "Ver",
      width: 60,
      align: "center",
      sortable: false,
      filterable: false,
      render: (fila) =>
        fila.children.length !== 0 && (
          <button
            className="btn btn-success btn-sm btn-icon-text"
            title="Bajar un nivel"
            onClick={() => retornarNivel(fila)}
          >
            <i className="mdi mdi-arrow-right-bold"></i>
          </button>
        ),
    },
    {
      field: "_back",
      title: "",
      width: 60,
      align: "center",
      sortable: false,
      filterable: false,
      render: (fila) => (
        <button
          className="btn btn-warning btn-sm btn-icon-text"
          title="Regresar un nivel"
          onClick={() => returnChildren(fila)}
        >
          <i className="mdi mdi-arrow-left-bold"></i>
        </button>
      ),
    },
  ];

  if (puedeEliminar) {
    childColumns.push({
      field: "_delete",
      title: "",
      width: 60,
      align: "center",
      sortable: false,
      filterable: false,
      render: (fila) => (
        <button
          className="btn btn-danger btn-sm btn-icon-text"
          title="Eliminar cuenta"
          onClick={() => {
            setCuenta(fila.cuenta_presupuental);
            setNomCuenta(fila.nombre_hijo);
            setIDCuenta(fila.id);
            setCuentaTipo("hijo");
            setModalEliminar(true);
          }}
        >
          <i className="mdi mdi-delete-forever"></i>
        </button>
      ),
    });
  }

  return (
    <>
      <ModaladdPadre
        ModalPadre={ModalPadre}
        togglePadre={togglePadre}
        NombrePadre={NombrePadre}
        NumeracionPadre={NumeracionPadre}
        NivelPadre={NivelPadre}
        GrupoPadre={GrupoPadre}
        UpdatePadre={UpdatePadre}
        IDPadre={IDPadre}
        token={token}
        setNombrePadre={setNombrePadre}
        setNumeracionPadre={setNumeracionPadre}
        setNivelPadre={setNivelPadre}
        setGrupoPadre={setGrupoPadre}
        PresupuestosGetService={PresupuestosGetService}
      />

      <ModalSubpadre
        ModalSub={ModalSub}
        toggleSubPadre={toggleSubPadre}
        PadreID={PadreID}
        HijoID={HijoID}
        NombreSub={NombreSub}
        NivelID={NivelID}
        token={token}
        setPadreID={setPadreID}
        setHijoID={setHijoID}
        setNombreSub={setNombreSub}
        setNivelID={setNivelID}
        PresupuestosGetService={PresupuestosGetService}
      />

      <ModalHijo
        modalHijo={modalHijo}
        toggleHijo={toggleHijo}
        PadreID={PadreID}
        HijoID={HijoID}
        NombreH={NombreH}
        NivelID={NivelID}
        VariableID={VariableID}
        Cantidad={Cantidad}
        Unidades={Unidades}
        X={X}
        MostrarVariable={MostrarVariable}
        NombreVari={NombreVari}
        NumeracionVari={NumeracionVari}
        IsChecked={IsChecked}
        Fecha={Fecha}
        Opcion={Opcion}
        Cuantos={Cuantos}
        Costo={Costo}
        Subtota={Subtota}
        Iva={Iva}
        Total={Total}
        token={token}
        setPadreID={setPadreID}
        setHijoID={setHijoID}
        setNombreH={setNombreH}
        setNivelID={setNivelID}
        setVariableID={setVariableID}
        setCantidad={setCantidad}
        setX={setX}
        setUnidades={setUnidades}
        setMostrarVariable={setMostrarVariable}
        setNombreVari={setNombreVari}
        setNumeracionVari={setNumeracionVari}
        setIsChecked={setIsChecked}
        setFecha={setFecha}
        setOpcion={setOpcion}
        setCuantos={setCuantos}
        setCosto={setCosto}
        setSubtota={setSubtota}
        setIva={setIva}
        setTotal={setTotal}
        PresupuestosGetService={PresupuestosGetService}
      />

      <ModalFechas
        ModalFecha={ModalFecha}
        toggleFecha={toggleFecha}
        IDFecha={IDFecha}
        token={token}
        PresupuestosGetService={PresupuestosGetService}
      />

      <ModalElim
        ModalEliminar={ModalEliminar}
        toggleEliminar={toggleEliminar}
        IDCuenta={IDCuenta}
        Cuenta={Cuenta}
        NomCuenta={NomCuenta}
        CuentaTipo={CuentaTipo}
        token={token}
        PresupuestosGetService={PresupuestosGetService}
      />

      <ModalEditar
        ModalEditarCampo={ModalEditarCampo}
        toggleEditar={toggleEditar}
        Campo={Campo}
        ValorCampo={ValorCampo}
        IDCampo={IDCampo}
        Tipo={Tipo}
        token={token}
        setCampo={setCampo}
        setValorCampo={setValorCampo}
        setIDCampo={setIDCampo}
        setTipo={setTipo}
        PresupuestosGetService={PresupuestosGetService}
      />
      <section style={{ paddingTop: 10, paddingBottom: 50 }}>
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <h2>Presupuestos</h2>
            </div>
            {Children.length === 0 ? (
              <>
                <div className="col-md-6 text-end">
                  <a className="btn btn-info" onClick={togglePadre}>
                    Agregar cuenta Padre
                  </a>
                </div>
              </>
            ) : (
              ""
            )}
          </div>
          <br />
          <div className="row">
            <div className="col-sm-4 grid-margin">
              <div className="card">
                <div className="card-body">
                  <h5>Subtotal</h5>
                  <div className="row">
                    <div className="col-8 col-sm-12 col-xl-8 my-auto">
                      <div className="d-flex d-sm-block d-md-flex align-items-center">
                        <h2 className="mb-0">${formatNumber(Subtotal)}</h2>
                      </div>
                    </div>
                    <div className="col-4 col-sm-12 col-xl-4 text-center text-xl-right">
                      <i className="icon-lg mdi mdi-currency-usd text-primary ml-auto"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-4 grid-margin">
              <div className="card">
                <div className="card-body">
                  <h5>IVA</h5>
                  <div className="row">
                    <div className="col-8 col-sm-12 col-xl-8 my-auto">
                      <div className="d-flex d-sm-block d-md-flex align-items-center">
                        <h2 className="mb-0">${formatNumber(Iva_)}</h2>
                      </div>
                    </div>
                    <div className="col-4 col-sm-12 col-xl-4 text-center text-xl-right">
                      <i className="icon-lg mdi mdi-currency-usd text-primary ml-auto"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-4 grid-margin">
              <div className="card">
                <div className="card-body">
                  <h5>Total</h5>
                  <div className="row">
                    <div className="col-8 col-sm-12 col-xl-8 my-auto">
                      <div className="d-flex d-sm-block d-md-flex align-items-center">
                        <h2 className="mb-0">${formatNumber(Total_)}</h2>
                      </div>
                    </div>
                    <div className="col-4 col-sm-12 col-xl-4 text-center text-xl-right">
                      <i className="icon-lg mdi mdi-currency-usd text-primary ml-auto"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              {Children.length > 0 ? (
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <button
                        onClick={() => {
                          setChildren([]);
                        }}
                        className="btn text-uppercase"
                      >
                        {NomPadre}
                      </button>
                    </li>
                    {array_titles.map((a) => (
                      <li key={a.nombre} className="breadcrumb-item">
                        <button
                          className="btn text-uppercase"
                          onClick={() => returnChildren(a, "nivel")}
                        >
                          {a.nombre}
                        </button>
                      </li>
                    ))}
                  </ol>
                </nav>
              ) : (
                ""
              )}
            </div>
          </div>
          {Children.length === 0 ? (
            <div className="row">
              <div className="col-md-12">
                <div className="crud-card">
                  <GroupedTable tableKey="presupuestos-padre" loading={loading}
                    data={Presupuestos}
                    groupField="grupo"
                    columns={parentColumns}
                    aggregates={TOTALES}
                    formatCurrency={formatCurrency}
                  />
                </div>
              </div>
            </div>
          ) : (
            ""
          )}
          {Children.length > 0 ? (
            <div className="crud-card">
              <DataTable tableKey="presupuestos-padre-hijos" loading={loading} columns={childColumns} data={Children} pageSize={20} />
            </div>
          ) : (
            ""
          )}
        </div>
      </section>
    </>
  );
}
